/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Column_PaymentInputs */

const en_case_payment_column_payment = /** @type {(inputs: Case_Payment_Column_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment`)
};

const pt_br2_case_payment_column_payment = /** @type {(inputs: Case_Payment_Column_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento`)
};

/**
* | output |
* | --- |
* | "Payment" |
*
* @param {Case_Payment_Column_PaymentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_column_payment = /** @type {((inputs?: Case_Payment_Column_PaymentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Column_PaymentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_column_payment(inputs)
	return pt_br2_case_payment_column_payment(inputs)
});